import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { renderMdInline } from "./markdown";

export default function FindingsCard({ icon: Icon, title, tone, items, testid }) {
  const tones = {
    success: "text-[#2C5C43]",
    danger: "text-[#A84632]",
    accent: "text-[#C26D5C]",
  };
  return (
    <Card className="bg-white border-[#E5E0D8] shadow-none" data-testid={testid}>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Icon size={18} strokeWidth={1.5} className={tones[tone]} />
          <CardTitle className="font-serif-display text-xl text-[#1F382E]">{title}</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <ul className="space-y-3 text-sm text-[#1A1A1A]">
          {items.length === 0 && <li className="text-[#5C665D]">Nothing notable.</li>}
          {items.map((t, i) => (
            <li key={i} className="flex gap-2.5 leading-relaxed">
              <span
                className={`mt-2 h-1.5 w-1.5 rounded-full shrink-0 ${tones[tone]}`}
                style={{ background: "currentColor" }}
              />
              <span>{renderMdInline(t)}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
